<template>
  <v-tooltip left>
    <template #activator="{ on }">
      <span v-on="on">
        <v-btn
          :disabled="disabled"
          color="warning"
          icon
          v-on="$listeners"
        >
          <v-icon>
            lock
          </v-icon>
        </v-btn>
      </span>
    </template>
    {{ `Change password for ${updatableName}` }}
  </v-tooltip>
</template>

<script>
export default {
  name: 'UmsPasswordChangeActivator',
  props: {
    updatableName: {
      type: [String, Number],
      default: '',
    },
    disabled: Boolean,
  },
};
</script>
